const CrmBrand = () => {
  return (
    <>
      <section className="crm-brand">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="text-center">
                <h4 className="mb-0 fw-semibold clr-text">
                  Trusted by More than 80 Million Users Globally
                </h4>
              </div>
            </div>
          </div>
          <div className="crm-brands-row mt-4">
            <div className="crm-brand-item">
              <img
                src="assets/img/icons/lattice-gray.png"
                alt="lattice"
                className="gray img-fluid"
              />
              <img
                src="assets/img/icons/lattice-black.png"
                alt="lattice"
                className="black img-fluid"
              />
            </div>
            <div className="crm-brand-item">
              <img
                src="assets/img/icons/northwest-gray.png"
                alt="northwest"
                className="gray img-fluid"
              />
              <img
                src="assets/img/icons/northwest-black.png"
                alt="northwest"
                className="black img-fluid"
              />
            </div>
            <div className="crm-brand-item">
              <img
                src="assets/img/icons/hellosign-gray.png"
                alt="hellosign"
                className="gray img-fluid"
              />
              <img
                src="assets/img/icons/hellosign-black.png"
                alt="hellosign"
                className="black img-fluid"
              />
            </div>
            <div className="crm-brand-item">
              <img
                src="assets/img/icons/getaround-gray.png"
                alt="getaround"
                className="gray img-fluid"
              />
              <img
                src="assets/img/icons/getaround-black.png"
                alt="getaround"
                className="black img-fluid"
              />
            </div>
            <div className="crm-brand-item">
              <img
                src="assets/img/icons/lattice-gray.png"
                alt="lattice"
                className="gray img-fluid"
              />
              <img
                src="assets/img/icons/lattice-black.png"
                alt="lattice"
                className="black img-fluid"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CrmBrand;
